module.exports = __webpack_public_path__ + "img/MEDIA053.8b45b584.jpg";